import { authenticateUser } from "@/utils/passwordAuth";
import { useEffect, useState } from "react";

export function useAuthentication() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true); // Ensure this runs only on the client side

    const appPassword = process.env.NEXT_PUBLIC_APP_PASSWORD;
    if (authenticateUser(appPassword)) {
      setIsAuthenticated(true);
    }
  }, []);

  return { isAuthenticated, isClient };
}
